<script>
export default {
	props: {
		data: {
			type: Array,
			required: true
		}
	},
	methods: {
		toMonthNameShort(date) {
			const newDate = new Date(date);
			newDate.setDate(newDate.getDate() + 1);
			return newDate
				.toLocaleString("es-CL", { month: "short" })
				.replace(/\./, "");
		},
		toDayNumber(date) {
			const newDate = new Date(date);
			newDate.setDate(newDate.getDate() + 1);
			return newDate.toLocaleString("es-CL", { day: "numeric" });
		},
		getLikesCount(item) {
			return item.imagenes.reduce((acc, cur) => acc + cur.likes.length, 0);
		},
	},	
}
</script>
<template>
	<section id="albumes">
		<div 
			v-if="data"
			class="row">
			<div 
				v-for="item in data"
				:key="item.id_galeria"
				class="col-12 col-lg-6 col-xl-4 col-xxl-3 mb-3">
				<div class="card border-0 card-list">
					<div class="card-body p-2">
						<router-link 
							:to="`/galeria/${item.id_galeria}`"
							class="card-list-link"
						>
							<span class="card-list-date">
								{{ toDayNumber(item.fecha_galeria) }}
								<small>
									{{ toMonthNameShort(item.fecha_galeria) }}
								</small>
							</span>
							<img 
								v-if="item.imagenes[0].url_imagen_original && item.imagenes[0].url_imagen_original != '' "
								:src="item.imagenes[0].url_imagen_original"
								class="card-list-img"
							>
							<div class="p-2">
								<h5 class="card-title h5-custom card-list-title font-main text-secondary h5-custom">
									{{ item.titulo_galeria }}
								</h5>
								<div class="d-flex align-items-center justify-content-end">
									<a 
										href="javascript:"
										class="card-custom-footer-like ms-2 color-main"
									>
										<span 
										v-if="getLikesCount(item) === 0" 
										key="solid-heart"
										>
										<font-awesome-icon icon="fa-solid fa-heart"></font-awesome-icon>
										</span>
										<span 
										v-if="getLikesCount(item) > 0" 
										key="regular-heart"
										>
										<font-awesome-icon icon="fa-solid fa-heart" class="color-red"></font-awesome-icon>
										</span>
									</a>
									<span class="card-custom-footer-like-count ms-2">
										{{ getLikesCount(item) }}
									</span>
									<a 
										href="javascript:"
										class="card-custom-footer-like ms- color-main ms-2"
									>
										<font-awesome-icon icon="fa-solid fa-image"></font-awesome-icon>
									</a>
									<span class="card-custom-footer-like-count ms-2">
										{{ item.imagenes.length }}
									</span>
								</div>
							</div>	
						</router-link>
					</div>
				</div>
			</div>
		</div>

		<div 
			v-if="data.length === 0"
			class="row">
			<div class="col-12">
				<div class="card border-0 text-center">
					<div class="card-body p-5">
						<h5 class="text-secondary h5-custom mb-0">						
							<font-awesome-icon icon="fa-solid fa-circle-info" class="color-yellow"></font-awesome-icon>
							Este mes no se han creado <strong>galerías.</strong>
						</h5>
					</div>
				</div>
			</div>
		</div>

	</section>
</template>